import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.feature-sets.legal-entity-list-view`

export default defineMessages({
  activeTabLabel: {
    id: `${scope}.activeTabLabel`,
    defaultMessage: 'Active entities',
  },
  inactiveTabLabel: {
    id: `${scope}.inactiveTabLabel`,
    defaultMessage: 'Inactive entities',
  },
})
